import { query } from '@/dex-shared/helpers/graphql';

export default {
  async GET_QUESTION_ID_BY_LIST_SLUG_AND_INDEX(
    { commit }: any,
    { listSlug, index }: { listSlug: string; index: number },
  ) {
    const response = await query(
      `query QuestionByListSlugAndIndex($listSlug: String, $index: Int) {
              questionByListSlugAndIndex(listSlug: $listSlug, index: $index){
                     id
                }
            }`,
      {
        listSlug,
        index,
      },
    );
    const idOfQuestion = response.data.questionByListSlugAndIndex.id;
    commit('SET_QUESTION_ID_LIST_SLUG_INDEX', {
      listSlug,
      index,
      questionId: idOfQuestion,
    });
    return idOfQuestion;
  },
};
